var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8896_165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8896_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54813 14.583C7.12715 14.583 6.77083 14.4372 6.47917 14.1455C6.1875 13.8538 6.04167 13.4975 6.04167 13.0766V3.58947C6.04167 3.16849 6.1875 2.81217 6.47917 2.52051C6.77083 2.22884 7.12715 2.08301 7.54813 2.08301H14.5352C14.9562 2.08301 15.3125 2.22884 15.6042 2.52051C15.8958 2.81217 16.0417 3.16849 16.0417 3.58947V13.0766C16.0417 13.4975 15.8958 13.8538 15.6042 14.1455C15.3125 14.4372 14.9562 14.583 14.5352 14.583H7.54813ZM7.54813 13.333H14.5352C14.5994 13.333 14.6581 13.3063 14.7115 13.2528C14.7649 13.1995 14.7917 13.1407 14.7917 13.0766V3.58947C14.7917 3.5253 14.7649 3.46655 14.7115 3.41322C14.6581 3.35974 14.5994 3.33301 14.5352 3.33301H7.54813C7.48396 3.33301 7.42521 3.35974 7.37188 3.41322C7.3184 3.46655 7.29167 3.5253 7.29167 3.58947V13.0766C7.29167 13.1407 7.3184 13.1995 7.37188 13.2528C7.42521 13.3063 7.48396 13.333 7.54813 13.333ZM4.63146 17.4997C4.21049 17.4997 3.85417 17.3538 3.5625 17.0622C3.27083 16.7705 3.125 16.4142 3.125 15.9932V5.88113C3.125 5.70377 3.18486 5.55523 3.30458 5.43551C3.42417 5.31592 3.57264 5.25613 3.75 5.25613C3.92736 5.25613 4.0759 5.31592 4.19563 5.43551C4.31521 5.55523 4.375 5.70377 4.375 5.88113V15.9932C4.375 16.0574 4.40174 16.1161 4.45521 16.1695C4.50854 16.2229 4.56729 16.2497 4.63146 16.2497H12.2435C12.4209 16.2497 12.5694 16.3095 12.6892 16.4291C12.8088 16.5488 12.8685 16.6973 12.8685 16.8747C12.8685 17.052 12.8088 17.2005 12.6892 17.3201C12.5694 17.4398 12.4209 17.4997 12.2435 17.4997H4.63146Z",
    fill: "#656575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.59aa0eec068e4f22211a94f0fd1fc602.svg";
export { ForwardRef as ReactComponent };